import SEO from "../../data/seo";
import HeaderFour from "../../layout/headers/header-four";
import AboutMain from "./about";
import Video from "./video";
import Certification from "./certification";
import Team from "./team";
import FooterFour from "../../layout/footers/footer-four";
import { Link } from 'react-router-dom';

const AboutUs = () => {
    return (
        <>
            <SEO pageTitle="Hakkımızda" />
            <style>
                {`
                    .contact-link {
                        color: inherit;
                        text-decoration: none;
                        transition: color 0.3s ease;
                        display: block;
                    }
                    .contact-link:hover {
                        color: #0E357B !important;
                        text-decoration: none;
                    }
                    .contact-link:hover p {
                        color: #0E357B !important;
                    }
                    .contact-box {
                        border: 1px solid #eee;
                        border-radius: 10px;
                        box-shadow: 0 0 15px rgba(0,0,0,0.1);
                        transition: all 0.3s ease;
                    }
                    .contact-box:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 5px 20px rgba(0,0,0,0.15);
                    }
                    .map-container {
                        width: 100%;
                        height: 600px;
                        border-radius: 10px;
                        overflow: hidden;
                        margin-top: 30px;
                    }
                    .map-container iframe {
                        width: 100%;
                        height: 100%;
                        border: none;
                    }
                    .contact-text {
                        transition: color 0.3s ease;
                        color: #555555
                    }
                    .contact__area-left-contact-item-icon i {
                        color: #333333;
                    }
                    .contact__area-left-contact-item-content .text-center {
                        text-align: left !important;
                    }
                    .contact__area-left-contact-item-content p {
                        color: #555555 !important;
                        text-align: left !important;
                    }
                `}
            </style>
            <HeaderFour />
            <div
                className="bg-video"
                style={{ maxWidth: "100%", overflow: "hidden", position: "relative", height: "480px" }}
            >
                <video autoPlay muted loop playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}>
                    <source src="https://buildgo-react.vercel.app/static/media/banner.b1e80eca5dee07cccccd.mp4" type="video/mp4" />
                </video>
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1,
                        width: "100%",
                    }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="breadcrumb__area-content" style={{ textAlign: "center" }}>
                                    <h2
                                        style={{
                                            fontWeight: 500,
                                            WebkitTextStrokeWidth: "1px",
                                            WebkitTextStrokeColor: "#FFFFFF",
                                            color: "transparent",
                                            fontSize: "80px",
                                        }}
                                    >
                                        Hakkımızda
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="contact__area-left">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 mb-4">
                                        <div className="contact-box text-center p-3 h-100">
                                            <div className="contact__area-left-contact-item-icon mt-4">
                                            <i class="fa-regular fa-moon"></i>
                                            <i class="fa-regular fa-star"></i>
                                            </div>
                                            <div className="contact__area-left-contact-item-content text-center">
                                                <span className="d-block mb-3 mt-3">Ayyıldız İnşaat</span>
                                                <div className="text-center mb-30">
                                                <p>1987 yılında temelleri atılan Ayyıldız İnşaat, kurucumuz ve genel müdürümüz olan Hasan Hüseyin Ayyıldız'ın vizyoner liderliğinde ve yenilikçi yaklaşımıyla, Türkiye'nin inşaat sektöründe öncü firmalarından biri olarak konumunu güçlendirmiştir. Konusunda uzman teknik kadromuz, yılların verdiği tecrübe ve güçlü kurumsal yapımızla, her projemizde mükemmelliği hedefleyerek müşterilerimizin beklentilerinin ötesine geçmeyi başarıyoruz.</p>

                                                <p>Faaliyet alanlarımızda gösterdiğimiz üstün başarılar ve tamamladığımız prestijli projeler, sektördeki güvenilirliğimizin ve uzmanlığımızın en önemli göstergesidir. Endüstriyel sanayi yapılarından modern idari binalara, kapsamlı eğitim komplekslerinden çağdaş ticaret merkezlerine, konforlu yaşam alanlarından teknik altyapı ve çevre düzenleme projelerine kadar geniş bir yelpazede, müşterilerimize en üst kalitede ve güvenilir hizmet sunmaktayız. Her projemizde, çağın gerektirdiği modern yapı teknolojilerini kullanarak, estetik ve fonksiyonelliği kusursuz bir uyumla bir araya getiriyoruz.</p>

                                                <p>Hayal ettiğiniz projeyi, birlikte hayata geçirebilmek dileğiyle.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 mt-30">
                                        <div className="contact-box text-center p-3 h-100">
                                            <div className="contact__area-left-contact-item-icon mt-4">
                                            <i class="fa-regular fa-eye"></i>
                                            </div>
                                            <div className="contact__area-left-contact-item-content text-center">
                                                <span className="d-block mb-3 mt-3">Vizyonumuz</span>
                                                <div className="text-center mb-30">
                                                <p>Modern teknoloji ve yenilikçi çözümlerle, inşaat sektöründe kalite standartlarını yükseltmeyi hedefliyoruz. Her projemizde, planlama aşamasından teslime kadar olan süreçte, maksimum verimlilik ve müşteri memnuniyetini esas alıyoruz. Yatırımcılarımıza sunduğumuz kapsamlı hizmetlerimiz arasında ön fizibilite çalışmaları, mimari tasarım, proje yönetimi ve anahtar teslim çözümler yer almaktadır.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 mt-30">
                                        <div className="contact-box text-center p-3 h-100">
                                            <div className="contact__area-left-contact-item-icon mt-4">
                                            <i class="fa-regular fa-earth-europe"></i>
                                            </div>
                                            <div className="contact__area-left-contact-item-content text-center">
                                                <span className="d-block mb-3 mt-3">Misyonumuz</span>
                                                <div className="text-center mb-30">
                                                <p>Güvenilirlik, şeffaflık ve kalite ilkelerimizden ödün vermeden, sektördeki öncü konumumuzu sürdürmeyi amaçlıyoruz. Her projemizde sürdürülebilir başarıyı hedeflerken, çevreye duyarlı yaklaşımımız ve sosyal sorumluluklarımızın bilinciyle hareket ediyoruz. İş ortaklarımız ve müşterilerimizle kurduğumuz güvene dayalı ilişkiler, başarımızın temelini oluşturmaktadır.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterFour />
        </>
    );
};

export default AboutUs;